import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from 'react-router-dom';
import almusbahLogo from './assets/almusbahlogo.png'; // Add your logo image here
import codovioLogo from './assets/codoviologo.png'; // Add your logo image here

function App() {
  return (
    <div className="container py-5">
      <header className="d-flex justify-content-between align-items-center mb-4 border-bottom pb-3">
        <div className="d-flex align-items-center gap-2">
          <img src={codovioLogo} alt="Codovio Logo" style={{ height: '50px' }} />
        
        </div>
        <div>
          <img src={almusbahLogo} alt="Al Musbah Logo" style={{ height: '50px' }} />
        </div>
      </header>

      <main className="text-center">
        <h1 className="mb-4">Welcome to the Map App</h1>
        <p>
          <Link className="btn btn-primary" to="/add-branch-location">
            Go to Add Branch Location Map
          </Link>
        </p>
      </main>
    </div>
  );
}

export default App;
